import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { isMobile, handleEnterKey } from 'app/helpers/utils';

const getGraphic = name => {
  switch (name) {
    case 'Local Listings':
      return 'utensils';
    case 'Guest Communication':
      return 'users';
    case 'Maps':
      return 'map-marked';
    case 'Press':
      return 'newspaper';
    case 'Security':
      return 'lock';
    case 'SEO':
      return 'globe-americas';
    case 'Shareability':
      return 'thumbs-up';
    case 'ADA Accessibility':
      return 'universal-access';
    case 'Analytics':
      return 'chart-bar';
    case 'Integrations':
      return 'exchange';
    case 'Mobile Design':
      return 'mobile-alt';
    case 'Reservations':
      return 'concierge-bell';
    case 'Social Media':
      return 'comments';
    case 'Menu Code':
      return 'code';
    case 'Menu Optimization':
      return 'book-open';
    case 'Visibility':
      return 'binoculars';
    case 'Loyalty':
      return 'envelope';
    default:
      return null;
  }
};

const Icon = styled(
  ({
    dimension,
    graphic,
    small,
    children,
    onClick,
    className,
    hover,
    ...rest
  }) => (
    <a
      className={`fas fa-${getGraphic(graphic)} ${className}`}
      onClick={onClick}
      onKeyPress={e => handleEnterKey(e, onClick)}
      tabIndex={onClick ? 0 : -1}
      {...rest}
    >
      {children}
    </a>
  ),
)`
  cursor: ${({ onClick }) => (onClick ? 'pointer' : 'normal')};
  background: #f8f8f8;
  font-size: ${({ small, dimension }) => (small ? 20 : dimension / 3)}px;
  height: ${({ small, dimension }) => (small ? 40 : dimension)}px;
  width: ${({ small, dimension }) => (small ? 40 : dimension)}px;
  border-radius: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 0 auto;
  position: relative;

  ${({ hover }) =>
    hover &&
    `
    transition: ease 0.1s;
    &:hover, &:focus{
      color:white;
      background:#f49f61;
      font-weight:500;
    }
  `};
`;

Icon.defaultProps = {
  onClick: null,
  small: false,
  hover: false,
  dimension: 71,
};

Icon.propTypes = {
  onClick: PropTypes.func,
  small: PropTypes.bool.isRequired,
  hover: PropTypes.bool.isRequired,
  dimension: PropTypes.number.isRequired,
};

export default Icon;
